import { wrapSignalWithTimeout } from "./signal.js";
/** Make a fetch request with a timeout */
export function fetchWithTimeout(url, init) {
    if (init?.timeout) {
        const { cancel, signal } = wrapSignalWithTimeout(init.timeout, init.timeoutMessage ?? "Timeout", init.signal ?? undefined);
        return fetch(url, { ...init, signal }).finally(cancel);
    }
    else
        return fetch(url, init);
}
